import { Fragment } from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline'

export default function WeightAvailabilitySection({ 
    equipmentKey = '',
    title = '', 
    iconUrl = '', 
    availabilityJSON = [], 
    maxQuantity = 4,
    mutateEquipmentProfile = () => {},
    isExpanded = false,
    onToggleExpand,
    animated = false
}) {
    const currentQuantity = availabilityJSON.reduce((sum, item) => sum + item.quantity, 0)
    const totalMaxQuantity = availabilityJSON.reduce((sum) => sum + maxQuantity, 0)

    const expandedContent = (
                <div className="divide-y divide-gray-300">

                    <div className='grid grid-cols-2 divide-x divide-gray-300 text-gray-600'> 
                        <div 
                            className='p-4 flex items-center justify-center gap-x-2 cursor-pointer'
                            onClick={() => mutateEquipmentProfile('remove-all-weight-availability', equipmentKey)}
                        >
                            {/* <MinusCircleIcon className="h-6 w-6" /> */}
                            <div className='text-sm'>Remove All</div>
                        </div>
                        <div 
                            className='p-4 flex items-center justify-center gap-x-2 cursor-pointer'
                            onClick={() => mutateEquipmentProfile('add-all-weight-availability', equipmentKey)}
                        >
                            <div className='text-sm'>Add All</div>
                            {/* <PlusCircleIcon className="h-6 w-6" /> */}
                        </div>
                    </div>

                    {/* Plate/Kettlebell Availability Options */}
                    {(equipmentKey === 'plate' || equipmentKey === 'kettlebell') && 
                        <>

                            {availabilityJSON.map((item, index) => (
                                <div 
                                    key={index}
                                    className={`flex items-center pl-6 pr-4 py-4 text-lg ${
                                        item.quantity === 0 ? 'bg-gray-100' : ''
                                    }`}
                                >

                                    {/* Quantity Label and Icon */}
                                    <div className="flex-1 flex items-center gap-x-3">

                                        <img 
                                            src={iconUrl} 
                                            alt={`${title} Icon`} 
                                            className="h-8 w-8"
                                        />

                                        <div className="font-medium text-gray-800">{item.weight} lbs</div>

                                    </div>

                                    {/* Quantity Buttons */}
                                    <div className="flex items-center gap-x-1">

                                        <button 
                                            onClick={() => mutateEquipmentProfile('decrement-weight-availability', equipmentKey, index)}
                                            className={`transition-colors ${
                                                item.quantity === 0 
                                                    ? 'text-gray-300 cursor-not-allowed' 
                                                    : 'text-gray-500 hover:text-gray-700'
                                            }`}
                                            disabled={item.quantity === 0}
                                        >
                                            <MinusCircleIcon className="h-8 w-8" />
                                        </button>

                                        <span className="w-6 text-center">{item.quantity}</span>

                                        <button 
                                            onClick={() => mutateEquipmentProfile('increment-weight-availability', equipmentKey, index)}
                                            className={`transition-colors ${
                                                item.quantity === maxQuantity 
                                                    ? 'text-gray-300 cursor-not-allowed' 
                                                    : 'text-gray-500 hover:text-gray-700'
                                            }`}
                                            disabled={item.quantity === maxQuantity}
                                        >
                                            <PlusCircleIcon className="h-8 w-8" />
                                        </button>

                                    </div>

                                </div>

                            ))}

                        </>
                    }

                    {/* Dumbbell Availability Options. Need to split this out because dumbbell options have some restrictions */}
                    {equipmentKey === 'dumbbell' && 
                        <>

                            {availabilityJSON.map((item, index) => (
                                <Fragment key={index}>

                                    {/* Dumbbells up to 20lbs are required */}
                                    {item.weight <= 20 && 
                                        <div className='flex items-center pl-6 pr-4 py-4 text-lg bg-gray-100'>

                                            {/* Quantity Label and Icon */}
                                            <div className="flex-1 flex items-center gap-x-3">

                                                <img 
                                                    src={iconUrl} 
                                                    alt={`${title} Icon`} 
                                                    className="h-8 w-8"
                                                />

                                                <div className="font-medium text-gray-800">{item.weight} lbs</div>

                                            </div>

                                            {/* Quantity Buttons */}
                                            <div className="flex items-center gap-x-1">

                                                <button 
                                                    className='text-gray-300 cursor-not-allowed'
                                                    disabled={true}
                                                >
                                                    <MinusCircleIcon className="h-8 w-8" />
                                                </button>

                                                <span className="w-6 text-center">{item.quantity}</span>

                                                <button 
                                                    className='text-gray-300 cursor-not-allowed'
                                                    disabled={true}
                                                >
                                                    <PlusCircleIcon className="h-8 w-8" />
                                                </button>

                                            </div>

                                        </div>
                                    }

                                    {/* All other dumbbells are optional */}
                                    {20 < item.weight && 
                                        <div 
                                            className={`flex items-center pl-6 pr-4 py-4 text-lg ${
                                                item.quantity === 0 ? 'bg-gray-100' : ''
                                            }`}
                                        >

                                            {/* Quantity Label and Icon */}
                                            <div className="flex-1 flex items-center gap-x-3">

                                                <img 
                                                    src={iconUrl} 
                                                    alt={`${title} Icon`} 
                                                    className="h-8 w-8"
                                                />

                                                <div className="font-medium text-gray-800">{item.weight} lbs</div>

                                            </div>

                                            {/* Quantity Buttons */}
                                            <div className="flex items-center gap-x-1">

                                                <button 
                                                    onClick={() => mutateEquipmentProfile('decrement-weight-availability', equipmentKey, index)}
                                                    className={`transition-colors ${
                                                        item.quantity === 0 
                                                            ? 'text-gray-300 cursor-not-allowed' 
                                                            : 'text-gray-500 hover:text-gray-700'
                                                    }`}
                                                    disabled={item.quantity === 0}
                                                >
                                                    <MinusCircleIcon className="h-8 w-8" />
                                                </button>

                                                <span className="w-6 text-center">{item.quantity}</span>

                                                <button 
                                                    onClick={() => mutateEquipmentProfile('increment-weight-availability', equipmentKey, index)}
                                                    className={`transition-colors ${
                                                        item.quantity === maxQuantity 
                                                            ? 'text-gray-300 cursor-not-allowed' 
                                                            : 'text-gray-500 hover:text-gray-700'
                                                    }`}
                                                    disabled={item.quantity === maxQuantity}
                                                >
                                                    <PlusCircleIcon className="h-8 w-8" />
                                                </button>

                                            </div>

                                        </div>
                                    }

                                </Fragment>
                            ))}

                        </>
                    }

                </div>
    )

    return (
        <div className={`bg-gray-100 rounded-lg overflow-hidden ${animated ? '' : 'divide-y divide-gray-300'}`}>
            
            <div 
                className="flex items-center justify-between px-6 py-4 cursor-pointer"
                onClick={onToggleExpand}
            >
                <div className="flex items-center gap-x-2">

                    <img 
                        src={iconUrl} 
                        alt={`${title} Icon`} 
                        className="h-6 w-6"
                    />

                    <span className="text-base font-semibold text-gray-800">{title}</span>

                    <span className="text-xs text-gray-500">({currentQuantity} of {totalMaxQuantity})</span>

                </div>

                <ChevronDownIcon 
                    className={`h-5 w-5 text-gray-500 transform transition-transform duration-300 ease-out ${
                        isExpanded ? 'rotate-180' : ''
                    }`}
                />

            </div>
            
            {animated ? (
                <div
                    className={`
                        grid transition-[grid-template-rows] duration-300 ease-out
                        ${isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}
                    `}
                >
                    <div className="min-h-0 overflow-hidden">
                        <div
                            className={`
                                border-t border-gray-300 transition-opacity duration-200 ease-out
                                ${isExpanded ? 'opacity-100' : 'pointer-events-none opacity-0'}
                            `}
                        >
                            {expandedContent}
                        </div>
                    </div>
                </div>
            ) : (
                isExpanded && expandedContent
            )}

        </div>
    )
} 